import { productAxiosInstance } from "@/services/axios";

export interface Review {
  id: number;
  customer_name: string;
  review: string;
  created_at: string;
}

export interface ReviewsResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: Review[];
}

export const getProductReviews = async (): Promise<ReviewsResponse> => {
  const response = await productAxiosInstance.get("/reviews/");
  return response.data;
};
